import React, { useMemo, useState } from 'react'
import { AcademyViewTable, LectureViewHeader } from '../Lecture/styles';
import { useAcademyList } from 'app/gomsacademy/hooks/AcademyList';
import { Select } from 'antd';

type ApprovalFilter = 'all' | 'none' | 'pending' | 'approved' | 'rejected'
type SortOption = 'name' | 'createdAt'

const APPROVAL_OPTIONS: { value: ApprovalFilter; label: string }[] = [
  { value: 'all', label: '전체' },
  { value: 'approved', label: '승인' },
  { value: 'pending', label: '대기' },
  { value: 'rejected', label: '반려' },
  { value: 'none', label: '미지정' },
]

const SORT_OPTIONS: { value: SortOption; label: string }[] = [
  { value: 'name', label: '이름순' },
  { value: 'createdAt', label: '등록일순' },
]

export const AcademyTotalTable = ({ setSelectAcademy, setIsTotal }) => {
  const { AcademyListData } = useAcademyList();
  const [approvalFilter, setApprovalFilter] = useState<ApprovalFilter>('all')
  const [sortBy, setSortBy] = useState<SortOption>('createdAt')

  const list = useMemo(() => {
    const raw = AcademyListData ?? []
    const filtered = approvalFilter === 'all'
      ? raw
      : raw.filter((it: any) => (it.approval_status ?? 'none') === approvalFilter)
    const sorted = [...filtered].sort((a: any, b: any) => {
      if (sortBy === 'name') return (a.name ?? '').localeCompare(b.name ?? '')
      return (b.createdAt ?? '').localeCompare(a.createdAt ?? '')
    })
    return sorted
  }, [AcademyListData, approvalFilter, sortBy])

  return (
    <>
      <LectureViewHeader>
        <p>전체</p>
        <div className='checkArea' style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <Select
            value={approvalFilter}
            onChange={setApprovalFilter}
            options={APPROVAL_OPTIONS}
            style={{ width: 120 }}
          />
          <Select
            value={sortBy}
            onChange={setSortBy}
            options={SORT_OPTIONS}
            style={{ width: 120 }}
          />
        </div>
      </LectureViewHeader>
      <div className='scroll'>
        <AcademyViewTable>
          <thead>
            <tr>
              <th>No.</th>
              <th>학원명</th>
              <th>대표원장</th>
              <th>아이디</th>
              <th className='phone'>전화번호</th>
              <th>주소</th>
              <th>등록일</th>
              <th>비고</th>
            </tr>
          </thead>
          <tbody>
            {list.map((it, idx) => (
              <tr key={it.id} className='trHover' onClick={() => {setSelectAcademy(it.id); setIsTotal(false)}}>
                <td>{idx + 1}</td>
                <td 
                  style={{
                    textDecoration: 'underline',
                    textAlign: 'left',
                    cursor: 'pointer'
                  }}
                >
                  {it.name}
                </td>
                <td>{it.representativeName}</td>
                <td>{it.email}</td>
                <td className='phone'>{it.tel}</td>
                <td>{it.address}</td>
                <td>{it.createdAt}</td>
                <td>{it.desc}</td>
              </tr>
            ))}
          </tbody>
        </AcademyViewTable>
      </div>
    </>
  )
}

export default React.memo(AcademyTotalTable)